/* Core & libraries */
import React, { useEffect, useState } from "react";
import { Modal, Carousel } from "react-bootstrap";
import { useTheme } from "react-jss";


/* Helpers, constants, custom methods, internal libraries */

/* Components */
import UCButton from "../../../components/buttons";
import UCModal from "../../ucmodal";
import { ReactComponent as LeftArrow } from "../../../resources/images/carousel-left-arrow.svg";
import { ReactComponent as RightArrow } from "../../../resources/images/carousel-right-arrow.svg";

/* Styles */
import styles from "./styles";



const ProgramCarouselModal = ({ setShow, show, currentIndex, handleSelect, images, setCurrentIndex, providerAirline }) => {
  const theme = useTheme();
  const classes = styles({ theme });

  const getCustomStyling = () => {
    switch (providerAirline) {
      case "american":
        return `${classes.contentStyle} ${classes.american}`;
      case "delta":
        return `${classes.contentStyle} ${classes.delta}`;
      case "united":
        return `${classes.contentStyle} ${classes.united}`;
      case "alaska":
        return `${classes.contentStyle} ${classes.alaska}`;
    }
  };

  return (
    <UCModal
      className={classes.carouselModal}
      showModal={ show }
      setShowModal={ setShow }
      modalIcon={
      <>
       <UCButton
         type="default"
         className={classes.arrowLeftButton}
         onClick={() => setCurrentIndex((currentIndex - 1 + images.length) % images.length)}
         icon={<LeftArrow />}
       />
       <UCButton
         type="default"
         className={classes.arrowRightButton}
         onClick={() => setCurrentIndex((currentIndex + 1) % images.length)}
         icon={<RightArrow />}
       />
      </>
    }
      modalContent={
        <div className={getCustomStyling()}>
          <Carousel
            activeIndex={currentIndex}
            onSelect={handleSelect}
            slide={false}
            interval={null}
            indicators={false}
            controls={false}
            className={classes.carouselContainer}
          >
            {images.map((image, index) => (
              <Carousel.Item key={index}>
                <img className={classes.carouselImage} src={image} alt={`Slide ${index + 1}`} />
              </Carousel.Item>
            ))}
          </Carousel>
        </div>
      }

    />
  );
};

export default ProgramCarouselModal;